$(function () {

    // Custom sort by dropdown
    $('.js-sortby').on('click', function() {
        $this = $(this);

        var sortLocation = $this.attr('data-sortby');
        location = '?orderby=' + sortLocation;

    });

});